import { z } from 'zod';

export const base64ImageSchema = z.object({
    fileName: z.string().min(1),
    contentType: z.string().regex(/^image\//),
    base64: z.string().min(10),
});
